<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';

import { useEditor } from '@/composables/useEditor';

import SelectionConfiguration from './SelectionConfiguration.vue';

const emits = defineEmits(['save']);

const { configurationAuto: config, overrideMainActionButton } = useEditor();

onMounted(() => {
  overrideMainActionButton.value = {
    text: 'Valider ma sélection',
    action() {
      emits('save');
    },
  };
});

onUnmounted(() => {
  overrideMainActionButton.value = undefined;
});
</script>

<template>
  <SelectionConfiguration v-model:config="config" />
</template>
